var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetirement20(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_714_704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.928 22V36C20.928 36 19.4213 31.8787 12.5173 27.4853",
    stroke: "#63363A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.928 36C20.928 36 22.4347 31.8786 29.34 27.4853M9.88133 30.3333C11.2493 31.8213 13.404 32.364 14.712 29.5813C17.948 27.6666 16.6213 25.2426 14.7827 23.9733C13.4242 23.3113 11.929 22.9785 10.4181 23.0016C8.90712 23.0248 7.42283 23.4033 6.08533 24.1066C8.29333 26.2466 8.17999 28.4786 9.88133 30.3333Z",
    stroke: "#63363A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.928 10H20.2173C19.8001 9.99702 19.395 10.1401 19.0723 10.4045C18.7495 10.6689 18.5295 11.0379 18.4503 11.4476C18.3711 11.8572 18.4378 12.2816 18.6388 12.6473C18.8398 13.0129 19.1624 13.2966 19.5506 13.4493L22.3013 14.5507C22.6867 14.7057 23.0061 14.9901 23.2048 15.3549C23.4035 15.7197 23.469 16.1423 23.3902 16.5502C23.3114 16.9581 23.0931 17.3258 22.7728 17.5904C22.4524 17.8549 22.0501 17.9997 21.6346 18H18.928M20.928 10V9M20.928 19V18M31.9746 30.3333C30.608 31.8213 28.452 32.364 27.1453 29.5813C23.9093 27.664 25.236 25.2413 27.0733 23.972C28.4319 23.3098 29.9273 22.9768 31.4386 23C32.9498 23.0232 34.4343 23.4018 35.772 24.1053C33.5626 26.2467 33.6773 28.4787 31.9746 30.3333Z",
    stroke: "#63363A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.928 14C12.928 15.0506 13.1349 16.0909 13.5369 17.0615C13.939 18.0321 14.5283 18.914 15.2711 19.6569C16.014 20.3997 16.8959 20.989 17.8665 21.391C18.8371 21.7931 19.8774 22 20.928 22C21.9786 22 23.0188 21.7931 23.9894 21.391C24.9601 20.989 25.842 20.3997 26.5848 19.6569C27.3277 18.914 27.917 18.0321 28.319 17.0615C28.7211 16.0909 28.928 15.0506 28.928 14C28.928 11.8783 28.0851 9.84344 26.5848 8.34315C25.0845 6.84285 23.0497 6 20.928 6C18.8062 6 16.7714 6.84285 15.2711 8.34315C13.7708 9.84344 12.928 11.8783 12.928 14Z",
    stroke: "#63363A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_714_704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetirement20);
export default __webpack_public_path__ + "static/media/Retirement2.0.0cc1d594228fe0a53a649d77e2ff020a.svg";
export { ForwardRef as ReactComponent };